import React from "react";
import PricingSection from "./PricingSection";
import FaQ from "./FaQ";
import CtaSection from "./CtaSection";
import LandingNav from "../Landing_Nav";
import LandingFooter from "../Landing_Footer";

const PricingPage = () => {
  return (
    <>
      <LandingNav />
      <PricingSection />
      <FaQ />
      <CtaSection />
      <LandingFooter />
    </>
  );
};

export default PricingPage;
